import axios from 'axios';
import { API_BASE_URL, STORAGE_KEYS } from '../constants/api';

/**
 * Axios instance — pre-configured with base URL and default headers.
 * All API modules should import and use this instance, not raw axios.
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  timeout: 10_000,
});

/** Attach Bearer token to every outgoing request when present. */
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
